export default __webpack_public_path__ + "static/media/diners-club.2808e877.jpg";